import axios from 'axios'

const BASE_URL = `${process.env.REACT_APP_DATA_LOGGER_BASE_URL}/v1`

export const getDataForTimeLineChart = async (data) => {
  console.log(data)
  try {
    const response = await axios.get(
      `${BASE_URL}/daily-report/timeline-chart/${data.machine}/${data.shift}`,
      {
        params: {
          date: data.date
        }
      }
    )
    return response
  } catch (err) {
    console.log(err)
    return err.response
  }
}
